"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contracts = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.contracts = require("./contracts");
//# sourceMappingURL=index.js.map